/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Empty_State_TitleInputs */

const fr_membership_empty_state_title = /** @type {(inputs: Membership_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun abonnement en ligne`)
};

/**

* @param {Membership_Empty_State_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_empty_state_title = /** @type {((inputs?: Membership_Empty_State_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Empty_State_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_empty_state_title(inputs)
});